import { useEffect } from 'react'
import { AppProviders } from '@/app/providers/AppProviders'
import { AppRouter } from '@/app/router'
import { useLandingContentStore } from '@/features/admin/content/landingContent'

export default function App() {
  // Carga el contenido del landing desde el backend una sola vez al iniciar.
  useEffect(() => {
    void useLandingContentStore.getState().load()
  }, [])

  return (
    <AppProviders>
      <AppRouter />
    </AppProviders>
  )
}
